import React, {useState} from "react";
import help_img from "../img/information-line.png"
import logo_eco from "../img/Logo eco by assur bon plan.png"
import DataDevis from "../dataDevis";
import logo_abp from "../img/Logo assur bon plan.png"
import logo_motard from "../img/motard4.png"
import question_mark from "../img/questionmark.png"


const showAxa = process.env.REACT_APP_SHOW_AXA === 'true'

const VoirPlus = ({xenaKey,detailSwitch}) => <span onClick={(e)=> { detailSwitch(xenaKey) ; e.stopPropagation() }}>Voir +</span>


const OptionRow = (p) => {

    const {xenaEncart,axaEncart} = p
    const {xena,axa,fma,periodicite,formule,changeParams,selectedOptions,detailSwitch,hasXena,hasSolly,hasAxa,hasFma} = p.container
    let w = xena.find( w => w.Z_CODOPT==p.xenaKey )

    let wa = axa.options?.[p.xenaKey]
    const xenaToFma = {'IP1':'GIP1*','IP2':'GIP2*','AC1':'ACC1*','AC2':'ACC3*','AST':'ASS3*'}
    let wfm = fma.getOption(xenaToFma[p.xenaKey])
    const fmaIncluded = fma.getIncludedOption( xenaToFma[p.xenaKey] )

    if (( p.xenaKey == 'AC1' || p.xenaKey == 'AC2' )&&( formule == 'M2' )) { w = undefined ; wa = undefined ; wfm = undefined }

    const checked = selectedOptions.includes(p.xenaKey)
    const sollyChecked = false

    const onChange = ()=>{
        let s = selectedOptions
        // Prevent IPx and ACx to be selected at once
        switch ( p.xenaKey ) {
            case 'IP1':
                s = s.filter( e => e!='IP2' )
                break;
            case 'IP2':
                s = s.filter( e => e!='IP1' )
                break;
            case 'AC1':
                s = s.filter( e => e!='AC2' )
                break;
            case 'AC2':
                s = s.filter( e => e!='AC1' )
                break;
        }
        if ( s.includes(p.xenaKey) ) {
            changeParams( {selectedOptions:s.filter( e=>e!=p.xenaKey ) } )
        } else {
            changeParams( {selectedOptions: [...s,p.xenaKey] } )
        }
    }

    return <tr><td onClick={(e)=> { detailSwitch(p.xenaKey) ; e.stopPropagation() }}><img src={question_mark}/>{p.children}
    
    </td>
    {hasXena && <td 
            className={( checked&&w ) ? 'tarif selected' : 'tarif'}
            onClick={onChange}
        >
        { w ? <>{DataDevis.fancyPrice(( periodicite == 'M' )?w.Z_MTMOP:w.Z_MTAOP)} € 
            <VoirPlus xenaKey={p.xenaKey} detailSwitch={detailSwitch}/>
            {xenaEncart && <i>{xenaEncart}</i>}
            </> :<i>Non disponible</i>}
    </td>}
    {hasSolly && <td 
        className={ sollyChecked ?'tarif selected':'tarif'}
        >
        <i>Non disponible</i>
    </td>}
    {hasAxa && <td 
            className={( checked&&wa )?'tarif selected':'tarif'}
            onClick={onChange}
            >
        {wa ? <>{axa.fancyPrice( (periodicite == 'M' )?wa.monthly:wa.yearly )}
            <VoirPlus xenaKey={p.xenaKey} detailSwitch={detailSwitch}/>
            {axaEncart && <i>{axaEncart}</i>}
            </> : <i>Non disponible</i> }
        </td>
    }
    {hasFma && <td 
            className={( checked&&wfm )?'tarif selected':'tarif'}
        onClick={onChange}
        >
        {fmaIncluded?<><VoirPlus xenaKey={p.xenaKey} detailSwitch={detailSwitch}/><h3>Inclus dans l'offre de base</h3></>:
        wfm?<>
            <VoirPlus xenaKey={p.xenaKey} detailSwitch={detailSwitch}/>
            { fma.fancyPrice( (periodicite == 'M' ) ? wfm.prime_M : wfm.prime_A ) }
        </>:<i>Non disponible</i>
        }
    </td>}

    </tr>
}


const DetailRow = (p) => {
    return p.unfold.includes(p.xenaKey) ? <tr>{p.children}</tr> : <></>
}


export default (props) => {

    const [unfold,setUnfold] = useState([])

    const detailSwitch = (code)=>{
        if ( unfold.includes(code) ) {
            setUnfold( unfold.filter(c=>c!=code))
        } else {
            setUnfold([code,...unfold])
        }
    }
    const {fma,axa,devis,bestMatch,comparateur,changeParams,hasXena,hasSolly,hasAxa,hasFma} = props.container
    axa.setFancy('-',' €')
    fma.setFancy('-',' €')
    const {solly_ref,params} = devis

    const {options,periodicite,formule,selectedOptions,axaSelectedOptions} = params

    const showXena = hasXena &&( comparateur || bestMatch[formule]=='xena' )
    const showSolly = hasSolly && comparateur
    const showAxa = hasAxa &&( comparateur || bestMatch[formule]=='axa' )
    const showFma = hasFma &&( comparateur || bestMatch[formule]=='fma' )

    const container = {
        nCols:comparateur?(hasXena?1:0)+(hasSolly?1:0)+(hasAxa?1:0)+(hasFma?1:0):1,
        hasXena:showXena,
        hasSolly:showSolly,
        hasAxa:showAxa,
        hasFma:showFma,
        bestMatch:bestMatch,
        comparateur:comparateur,
        xena:options||[],
        axa:axa,
        fma:fma,
        sollyRef:solly_ref,
        periodicite:periodicite,
        formule:formule,
        changeParams:changeParams,
        selectedOptions:selectedOptions || [],
        axaSelectedOptions:axaSelectedOptions || [],
        detailSwitch:detailSwitch
    }

    return <table className="comparateur">
        {comparateur && <thead>
            <tr><th></th>{hasXena && <th><img src={logo_eco}/></th>}{hasSolly && <th><img src={logo_abp}/></th>}{hasAxa && <th><img src={logo_motard}/></th>}{hasFma && <th>Assur Discount</th>}</tr>
        </thead>}
        <tbody>

            <tr><th colSpan={container.nCols+1}>Assistance</th></tr>
            <OptionRow xenaKey="AST" container={container}>
                <h3>Assistance Plus 0 km</h3>
            </OptionRow>
            <DetailRow xenaKey="AST" unfold={unfold}>
                <td className="formule_details"></td>
                {showXena && <td className="formule_details">
                    <p>Assistance pour l'assuré, son passager et son deux-roues, 24h/24 -
                    7j/7, en cas de panne, accident, vol, tentative de vol ou crevaison, perte de
                    clefs et enlèvement par la fourrière.
                    Incluant un <b>véhicule de remplacement</b> (auto ou moto*) pour toute durée d’immobilisation
                    supérieure à 48h (3 jours suite à une panne, 5 jours suite à un accident et 15 jours suite à
                    un vol du véhicule).
                    </p>
                </td>}
                {showSolly && <td className="formule_details"></td>}
                {showAxa && <td className="formule_details">
                    <p>Dépannage, remorquage en bas de chez vous, ou dans votre garage, 24h/24 7j/7, en moins d'une heure (sinon nous vous versons 
                        une indemnité de 30€) ; France métropolitaine et Monaco.
                        Prise en charge suite à accident, bris de glace, crevaison,
                        perte, bris ou vol de clefs.
                        Suite à panne de carburant ou énergie, panne d'origine mécanique, élétrique, éléctronique ou hydrolique.
                        Suite à incendie, vol ou tentative de vol, acte de vandalisme, attentat, évènement climatique, catastrophe natuelle ou technologique.
                        Sans franchise kilométrique. Dépannage remorquage à hauteur de 185€.
                    </p>
                </td>}
                {showFma && <td className="formule_details">
                    <p>{fma.displayOptionDescription('AST')}</p>
                </td>}
            </DetailRow>
            <tr><th colSpan={container.nCols+1}>Assurance Individuelle Pilote</th></tr>
            {showAxa && <tr className="formule_notice"><td>Inclus dans l'offre de base</td>
            {showXena && <td>Non</td>}
            {showSolly && <td>Non</td>}
            {showAxa && <td>Si taux d'invalidité &gt; 10%, versement d'une indemnité jusqu'à à 100.000 €</td>}
            {showFma && <td>Non</td>}
            </tr>}
            <OptionRow xenaKey="IP1" container={container} xenaEncart="Indemn. jusqu'à 300 000 €" axaEncart="Indemn. jusqu'à 500 000 €">
                <h3>Niveau 1</h3>
                <b>Nous vous <u>recommandons</u> cette option !</b>
            </OptionRow>
            <DetailRow xenaKey="IP1" unfold={unfold} colSpan={container.nCols+1}>
                <td className="formule_details"></td>
                {showXena && <td className="formule_details">
                    <p>Garantie du versement d’indemnités à vous ou à vos ayants droit en cas d’accident au guidon de votre deux-roues à hauteur de 300.000€. 
                    </p>
                </td>}
                {showSolly && <td className="formule_details"></td>}
                {showAxa && <td className="formule_details">
                    <p>Si taux d'invalidité &gt; 10%, versement d'une indemnité jusqu'à à 500.000 € ( 1.000.000 € avec gilet Airbag).<br/>
                    Si taux d'invalidité &le; 10%, indemnisation jusqu'à 1000 €</p>
                </td>}
                {showFma && <td className="formule_details">
                    <p>{fma.displayOptionDescription('IP1')}</p>
                </td>}
            </DetailRow>
            <OptionRow xenaKey="IP2" container={container} xenaEncart="Indemn. jusqu'à 800 000 €" axaEncart="Tx invalid. 5%">
                <h3>Niveau 2</h3>
            </OptionRow>

            <DetailRow xenaKey="IP2" unfold={unfold} colSpan={container.nCols+1}>
                <td className="formule_details"></td>
                {showXena && <td className="formule_details">
                <p>Garantie du versement d’indemnités à vous ou à vos ayants droit en cas d’accident au guidon de votre deux-roues à hauteur de 800.000€. 
                </p>
            </td>}
            {showSolly && <td className="formule_details"></td>}
            {showAxa && <td className="formule_details">
                <p>Si taux d'invalidité &gt; 5%, versement d'une indemnité jusqu'à à 500.000 € ( 1.000.000 € avec gilet Airbag).<br/>
                Si taux d'invalidité &le; 5%, indemnisation jusqu'à 2000 €</p>
            </td>}
                {showFma && <td className="formule_details">
                    <p>{fma.displayOptionDescription('IP2')}</p>
                </td>}
            </DetailRow>
            <tr><th colSpan={container.nCols+1}>Assurance accessoire</th></tr>
            <OptionRow xenaKey="AC1" container={container}>
                <h3>Niveau 1</h3>
            </OptionRow>

            <DetailRow xenaKey="AC1" unfold={unfold} colSpan={container.nCols+1}>
                <td className="formule_details"></td>
                {showXena && <td className="formule_details">
                <p>Garantie du remboursement des accessoires hors-série et équipement vestimentaire de protection du motard jusqu’à 1000 €. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. </p>
                </td>}
                {showSolly && <td className="formule_details"></td>}
                {showAxa && <td className="formule_details"></td>}
                {showFma && <td className="formule_details">
                    <p>{fma.displayOptionDescription('AC1')}</p>
                </td>}
            </DetailRow>
            <OptionRow xenaKey="AC2" container={container}>
                <h3>Niveau 2</h3>
            </OptionRow>

            <DetailRow xenaKey="AC2" unfold={unfold} colSpan={container.nCols+1}>
                <td className="formule_details"></td>
                {showXena && <td className="formule_details">
                <p>Assurance Accessoires jusqu’à 10000€. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. 
                </p>
                </td>}
                {showSolly && <td className="formule_details"></td>}
                {showAxa && <td className="formule_details"></td>}
                {showFma && <td className="formule_details">
                    <p>{fma.displayOptionDescription('AC2')}</p>
                </td>}
            </DetailRow>


        </tbody>
    </table>
}